import { FC } from 'react';
import { useSelector } from 'react-redux';
import {
  answersPageNumberSelector,
  answersRowsPerPageSelector,
  answersTotalPagesSelector,
} from '@selectors/answer';
import { MgState } from '@types';
import { TablePaginationComponent } from '@sharedComponents/TablePagination';

interface AnswerTablePaginationProps {
  handleChangePage: (event, newPage) => void;
  handleChangePageNumber: (value) => void;
  handleChangeRowsPerPage: (value) => void;
}

export const AnswerTablePagination: FC<AnswerTablePaginationProps> = ({
  handleChangePage,
  handleChangePageNumber,
  handleChangeRowsPerPage,
}) => {
  const pages = useSelector(answersTotalPagesSelector);
  const total = useSelector<MgState, number>(({ answer }) => answer?.total);
  const rowsPerPage = useSelector(answersRowsPerPageSelector);
  const page = useSelector(answersPageNumberSelector);

  return (
    <TablePaginationComponent
      rowsPerPage={rowsPerPage}
      handleChangePage={handleChangePage}
      handleChangePageNumber={handleChangePageNumber}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      pages={pages}
      page={page}
      total={total}
    />
  );
};
